import { render, staticRenderFns } from "./variation.vue?vue&type=template&id=f42857c2&scoped=true&lang=pug"
import script from "./variation.vue?vue&type=script&lang=coffee"
export * from "./variation.vue?vue&type=script&lang=coffee"
import style0 from "./variation.vue?vue&type=style&index=0&id=f42857c2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42857c2",
  null
  
)

export default component.exports